<div class="contenedor">
    <!--<div class="row">
        <div class="col-12" style="text-align: center; margin-bottom: 25px;">
            <h2 style="color: black;">
                Minuta N°{{nminute}} &nbsp;
                <mat-icon (click)="redirectMinute()" style="cursor: pointer;">description</mat-icon>
            </h2>
        </div>
        <div class="spinner" *ngIf="cargandoMinuteQR == true">
            <mat-spinner [diameter]="60"></mat-spinner>
        </div> 
    </div>-->

    <div [class.esconder]="cargandoMinuteQR" style="margin-bottom: 25px;">
      <div class="col-12">
        <h2 style="display: flex; justify-content: space-between; align-items: center;">
          <span>Información</span>
          <span (click)="redirectMinute()" style="background-color: #003c8a; color: white; border-radius: 12px; padding: 4px;">
            Minuta N°{{nminute}}
            <!--<mat-icon (click)="redirectMinute()" style="cursor: pointer;">description</mat-icon>-->
          </span>
        </h2>
        
        <hr />
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-md">
            <p>
              <b>Nombre: </b>
              {{
                client?.name
                  ? client?.name
                  : "-"
              }}
            </p>
            <p>
              <b>Rut: </b>
              {{
                client?.fullRut
                  ? client.fullRut
                  : "-"
              }}
            </p>
            <p>
              <b>A. Económica:</b>
              {{
                client?.currentEconomicActivity
                  ? client.currentEconomicActivity
                  : "Actividad No Registrada"
              }}
            </p>
            <p>
              <b>Email: </b>
              {{
                client?.email
                  ? client.email
                  : "-"
              }}
            </p>
            <p>
              <b>Creada: </b>
              {{
                minuteRequestRealTime?.createdAt
                  ? (minuteRequestRealTime.createdAt | date : "dd-MM-yyyy")
                  : "-"
              }}
            </p>
            <p>
              <b>Originador: </b>
                {{ snapshot?.createdBy.userName }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div [class.esconder]="cargandoMinuteQR" style="margin-bottom: 25px;">

      <div class="col-12">
        <h2>Comité</h2>
        <hr />
      </div>

      <div class="col-12">
        <div [class.esconder]="!minuteRequestRealTime?.hasChangeLineRequest && !minuteRequestRealTime?.operations">
            <div class="row">
                <div class="col-md-6">
                    <h3 class="space_title">Factoring</h3>
                </div>
            </div> 
            <div>               
                <!--<h3 class="space_title" style="text-decoration: underline;">Operaciones</h3>-->
                <div> 
                  <p>
                      <b>Nueva línea solicitada: </b>
                      <span>
                          {{minuteRequestRealTime?.factoringLine | currency : "CLP" : "symbol"}}
                      </span>
                  </p>
                  <app-operation-list *ngIf="!minuteRequestRealTime?.isClosed || (minuteRequestRealTime?.isClosed && minuteRequestRealTime?.operations.length>0)"
                      [operations]="minuteRequestRealTime?.operations"
                      [forMinute]="true">
                  </app-operation-list>
              </div>
            </div>
            <br >
        </div> 

        <div [class.esconder]="!minuteRequestRealTime?.hasChangeWarrantyLineRequest && !snapshot?.warranties">
          <div class="row">
              <div class="col-md-6">
                  <h3 class="space_title">Garantías</h3>
              </div>
          </div>
          <div>
            <p>
                <b>Nueva línea solicitada: </b>
                <span>
                    {{                
                        minuteRequestRealTime?.warrantyLine
                        | currency : "CLP" : "symbol"
                    }}    
                </span>
            </p>
            <app-warranties-minute *ngIf="!minuteRequestRealTime?.isClosed || (minuteRequestRealTime?.isClosed && snapshot?.warranties.length>0)"
                [warranties]="snapshot?.warranties"
                [forMinute]="true"
                >
            </app-warranties-minute>
          </div>
          <br >
        </div>

        <div>
          <div>
            <div class="row">
                <div class="col-12">
                    <h3 class="space_title">Deudores</h3>
                </div>
            </div>
            <div>
                <app-debtors-minute id="htmlDebtorMinute"
                    [minuteRequestId]="nminute"
                    [minuteDebtorResolutions]="minuteDebtors"
                    [canChangeResolution]="!minuteRequestRealTime?.isClosed">
                </app-debtors-minute>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div [class.esconder]="cargandoMinuteQR==true">
        <div class="col-12">
          <h2>Resolución</h2>
          <hr />
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-12">
              <div [ngSwitch]="resolutionName" class="resolution">
                <p *ngSwitchCase="'Pendiente'">
                  <b>Estado: </b>
                  <span class="resolution-status pending">Pendiente</span>
                </p>
                <p *ngSwitchCase="'Aprobado'">
                  <b>Estado: </b>
                  <span class="resolution-status approved">Aprobada</span>
                </p>
                <p *ngSwitchCase="'Rechazado'">
                  <b>Estado: </b>
                  <span class="resolution-status rejected">Rechazada</span>
                </p>
                <p *ngSwitchCase="'Eliminada'">
                  <b>Estado: </b>
                  <span class="resolution-status rejected">Eliminada</span>
                </p>
                <p *ngSwitchCase="'Cancelada'">
                  <b>Estado: </b>
                  <span class="resolution-status rejected">Cancelada</span>
                </p>
                <p *ngSwitchCase="'En Borrador'">
                  <b>Estado: </b>
                  <span class="resolution-status draft">Borrador</span>
                </p>
                <p *ngSwitchCase="'Pre-Aprobado'">
                  <b>Estado: </b>
                  <span class="resolution-status pre-approved">Pre-Aprobada</span>
                </p>
                <p *ngSwitchCase="'En Comité'">
                  <b>Estado: </b>
                  <span class="resolution-status comitee">En Comité</span>
                </p>
                <p *ngSwitchDefault>
                  <b>Estado: </b>
                  <span class="resolution-status">{{resolutionName}}</span>
                </p>
              </div>

              <p><b>Fecha: </b>
                {{ minuteRequestRealTime?.resolutedAt ? (minuteRequestRealTime.resolutedAt | date : "dd-MM-yyyy") : "-" }}
              </p>

              <p><b>Resoluciónes: </b>
              </p>
              <div class="row" style="width: 110%;">
                <div *ngFor="let resolution of minuteRequestRealTime?.resolutions" class="section_info_approve col-md-6">
                  <mat-card appearance="outlined">
                    <mat-card-body style="margin-bottom: 5px; padding: 4px">
                      <app-minute-resolution-item [minuteResolution]="resolution"></app-minute-resolution-item>
                    </mat-card-body>
                  </mat-card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="showButtons">
          <hr />
          <button class="btnAprobaciones" mat-stroked-button color="primary" (click)="approveMinuteConfirm()">
            Aprobar
          </button>
          <button class="btnAprobaciones" mat-stroked-button color="warn" style="float: right;" (click)="rejecMinuteConfirm()">
            Rechazar
          </button>
        </div>
        <div *ngIf="showReviewButtons">
          <hr>
          <button class="btnAprobaciones" mat-stroked-button color="primary" (click)="approveReviewMinuteConfirm()">
            Aprobar revisión
          </button>
          <button class="btnAprobaciones" mat-stroked-button color="warn" style="float: right;" (click)="rejecMinuteConfirm()">
            Rechazar revisión
          </button>

        </div>
    </div>

    <div style="padding-top: 1rem;" [ngClass]="{ 'esconder' : cargandoMinuteQR, 'button_container' : !cargandoMinuteQR }" >
      <div class="col-12">
        <button class="btnsMinute" (click)="closeMinuteConfirmation()" mat-raised-button color="primary"
          *ngIf="minuteRequestRealTime?.finalResolution === 0">
          Enviar a comité
        </button>
        <button class="btnsMinute" style="float: right;" (click)="updateMinutes()" color="accent" mat-raised-button
          *ngIf="!minuteRequestRealTime?.isClosed">
          Actualizar Minuta
        </button>
      </div>
    </div>

</div>


<ng-template #noInfo>
  <span>No hay info</span>
</ng-template>

